export const TEMPLATE_DESCRIPTION_MAX_LENGTH = 100;
export const TEMPLATE_MATCHER_PROMPT_MIN_LENGTH = 50;

export const templateDescriptionLength = (description: string) => description.length;
export const templateMatcherPromptLength = (matcherPrompt: string) => matcherPrompt.trim().length;

export const isTemplateDescriptionValid = (description: string) => (
  description.trim().length > 0 && templateDescriptionLength(description) <= TEMPLATE_DESCRIPTION_MAX_LENGTH
);

export const isTemplateMatcherPromptValid = (matcherPrompt: string) => (
  templateMatcherPromptLength(matcherPrompt) >= TEMPLATE_MATCHER_PROMPT_MIN_LENGTH
);

export const isTemplateMetadataValid = (description: string, matcherPrompt: string) => (
  isTemplateDescriptionValid(description) && isTemplateMatcherPromptValid(matcherPrompt)
);
